// extracted by mini-css-extract-plugin
module.exports = {"container":"MyTickets_container__2TRXX","headerTitle":"MyTickets_headerTitle__2P58X"};